import { Component, Input } from '@angular/core';

@Component({
    selector: 'dp-form-errors',
    templateUrl: './form-errors.component.html',
    styleUrls: ['./form-errors.component.scss']
})
export class FormErrorsComponent {
    @Input('field') public field;

    get errors() {
        const errorList = [];

        if (!this.field.errors) {
            return errorList;
        }

        return Object.keys(this.field.errors).map(name => {
            return this.getErrorMessage(name, this.field.errors[name]);
        });
    }

    public getErrorMessage(name, errObj) {
        switch (name) {
            case 'required':
                return 'Obrigatório';
            case 'email':
                return `Endereço de e-mail inválido`;
            case 'minlength':
                return `Deve ter no mínimo ${errObj.requiredLength} caracteres`;
            case 'maxlength':
                return `Deve ter no mínimo ${errObj.requiredLength} caracteres`;
            case 'invalidDate':
                return `Data inválida`;
            case 'invalidPhone':
                return `Telefone inválido`;
            default:
                return '';
        }
    }
}
